/**
 * @module app.ae
 */

import { autoinject, transient } from 'aurelia-framework';
import { Api } from 'app/shared/lib/api/api';
import { IApiActionResults, IApiQueryResults, IQueryLoadOptions } from 'app/shared/lib/api/api-types';
import { AppLogger } from 'app/shared/lib/logging/app-logger';
import * as AE from 'app/ae/models/essette-api';

@transient()
@autoinject()
export class AutomationEngineService {

    ////****************** Functions ************************************************////
    constructor(
        private readonly api: Api,
        private readonly logger: AppLogger) {

        this.logger.source = this;
    }

    ////****************** Settings *************************************************////


    ////****************** Queries **************************************************////


    ////****************** Loads ****************************************************////

    /** Requests all rule sets from Raven via the Essette API
     *  https://github.com/hmsholdings/essette-suite/blob/dev/docs/api/endpoints/models/AE/AE.RuleSet/RuleSet-query-info.md
     *  Rule sets cannot be filtered via the API, so only all rule sets can be queried.
     */
    public async loadAllRuleSets(): Promise<IApiQueryResults<AE.RuleSet>> {
        const query = this.api.query(`ae/ruleSets`);
        return await this.api.get(query);
    }

    ////****************** Actions **************************************************////

    /** Saves rule sets from Raven via the Essette API
     *  This same endpoint is used for creating, updating, and deleting rules.
     *  https://github.com/hmsholdings/essette-suite/blob/dev/docs/api/endpoints/models/AE/AE.RuleSet/RuleSet-save-info.md
     *  @param ruleSet The rule set to be saved
     */
    public async saveRuleSet(ruleSet: AE.RuleSet): Promise<IApiActionResults> {
        const action = this.api.action('save', 'ae/ruleSets/', ruleSet);
        return await this.api.post(action);
    }
}
